export interface UserModel {
  id: number | null;
  name: string;
  eventId: number | null;
  eventName: string;
}

export default function getModel(): UserModel {
  return {
    id: null,
    name: "",
    eventId: null,
    eventName: "",
  };
}
